module.exports = __webpack_public_path__ + "media/images/mto-logo-fee51e2b6c5043aa9f7868a3c18f048a.svg";